import {DateTime} from "luxon";

const DateDisplayerComp = ({ date }: { date: Date }) => (
  <span>{DateTime.fromJSDate(date).setLocale("fr").toFormat("dd/LL/yyyy")}</span>
);

export default DateDisplayerComp;
